import React from "react";
import "./Complete_Medical.css";
import Redirect_btn from "../../common-btn/redirect-btn/Redirect_btn";

const Complete_Medical = () => {
  return (
    <section className="complete_medical_section">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 col-md-8 col-sm-12">
            <div className="complete_medical_content_holder">
              <h2 className="complete_medical_title">
                Complete, Compliant & Fast Marine Medicals — All at One Place.
              </h2>

              <p className="complete_medical_text">
                From DG Shipping Medicals to Flag State Examinations, Hazardous
                Chemical Testing, and Corporate Crew Medicals, Shore Clinic
                ensures safe, accurate, and globally accepted certification for
                every seafarer.
              </p>
              <Redirect_btn name="Contact Now" link="/contact" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Complete_Medical;
